import { SubmissionError } from 'redux-form';
import { replace } from 'react-router-redux';

import getLocalRepresentative from '../../utils/localRepresentative/getLocalRepresentative';
import { width } from '../../utils/size';
import { CardTypes, LocalRepState } from '../../utils/enums';

import {
    ACTION_INITIATED_LOCAL_REP,
    SHOW_NEXT_ACTION_ANIMATION
} from '../Widget/actions';

export const ON_FIND_YOUR_REP_POPUP = 'ON_FIND_YOUR_REP_POPUP';
export const ON_FIND_YOUR_REP_ERROR = 'ON_FIND_YOUR_REP_ERROR';
export const ON_HIDE_REPRESENTATIVE = 'ON_HIDE_REPRESENTATIVE';
export const ON_SHOW_REPRESENTATIVE = 'ON_SHOW_REPRESENTATIVE';
export const ON_SHOW_LIST_WITH_REPS = 'ON_SHOW_LIST_WITH_REPS';
export const SET_LOCAL_REPRESENTATIVE = 'SET_LOCAL_REPRESENTATIVE';
export const LOCAL_REP_GO_TO_ACTION = 'LOCAL_REP_GO_TO_ACTION';
export const LOCAL_REP_GO_TO_FIND_SCREEN = 'LOCAL_REP_GO_TO_FIND_SCREEN';
export const IS_LOCAL_REP_LOADING = 'IS_LOCAL_REP_LOADING';
export const SET_ACTIVE_ACTION = 'SET_ACTIVE_ACTION';

export const onFindYourRep = () => dispatch => {
    dispatch({
        type: ON_FIND_YOUR_REP_POPUP,
        payload: true
    });
};

export const hideFindRepPopup = () => dispatch => {
    dispatch({
        type: ON_FIND_YOUR_REP_POPUP,
        payload: false
    });
};

export const goToFindLocalRep = (actionIdentifier, route) => dispatch => {
    dispatch({
        type: SET_ACTIVE_ACTION,
        payload: { actionIdentifier }
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: LOCAL_REP_GO_TO_FIND_SCREEN,
        payload: actionIdentifier
    });

    setTimeout(function() {
        dispatch({
            type: ACTION_INITIATED_LOCAL_REP,
            payload: actionIdentifier
        });
    }, 1000);

    dispatch(replace(`/${route}/findRep`));
};

export const hideFindRepCard = (cardType, nextActionType) => dispatch => {
    dispatch({
        type: LOCAL_REP_GO_TO_FIND_SCREEN,
        payload: null
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    if (cardType === CardTypes.multipleActions) {
        dispatch(replace('/multiActionsCard'));
    } else if (cardType === CardTypes.targetedMultiAction) {
        dispatch(replace('/targetedMultiAction'));
    } else {
        dispatch(replace(`/${nextActionType}/start`));
    }
};

const formatRepNameByLevel = rep => {
    const title = rep.level === LocalRepState.senators ? 'Sen' : 'Rep'
    const last = rep.fullName.split(' ').pop();
    return `${title} ${last}`;
};

const repDataWithShortRepNames = repData => {
    let augmentedRepData = repData;
    augmentedRepData.representative = repData.representative.map(r => ({
        ...r,
        shortName: formatRepNameByLevel(r)
    }));
    return augmentedRepData;
};

export const loadLocalRep = (address, isCalledFromForm, showOnlySenators) => dispatch => {
    if (!isCalledFromForm) {
        dispatch({
            type: IS_LOCAL_REP_LOADING,
            payload: true
        });
    }

    return getLocalRepresentative(address, showOnlySenators)
        .then(data => {
            dispatch({
                type: SET_LOCAL_REPRESENTATIVE,
                payload: repDataWithShortRepNames(data)
            });
            dispatch({
                type: ON_FIND_YOUR_REP_POPUP,
                payload: false
            });
            if (!isCalledFromForm) {
                dispatch({
                    type: IS_LOCAL_REP_LOADING,
                    payload: false
                });
            }

            if (typeof window !== 'undefined') window.dispatchEvent(new Event('resize'));
        })
        .catch(reason => {
            if (isCalledFromForm) {
                const error = 'ISSUE FINDING YOUR REP. PLEASE TRY AGAIN';
                const postalUsError = 'ADDRESSES MUST BE US BASED';
                const addressUsError = 'POSTAL CODE MUST BE US BASED';
                const senatorsNotAvailable = 'SENATORS NOT AVAILABLE. PLEASE TRY AGAIN';

                throw new SubmissionError({
                    _error: reason,
                    postalCodeInput:
                        reason === 'NotUsBasedError'
                            ? postalUsError
                            : reason === 'SenatorsNotAvailable'
                            ? senatorsNotAvailable
                            : error,
                    homeAddressInput:
                        reason === 'NotUsBasedError'
                            ? addressUsError
                            : reason === 'SenatorsNotAvailable'
                            ? senatorsNotAvailable
                            : error
                });
            } else {
                dispatch({
                    type: IS_LOCAL_REP_LOADING,
                    payload: false
                });
            }
        });
};

export const selectAction = identifier => dispatch => {
    var buttonClicked = document.querySelectorAll(
        '[data-action="' + identifier + '"]'
    )[0];
    if (buttonClicked) {
        buttonClicked.classList.add('clicked');
    }
    return;
};

export const onDeleteClick = item => dispatch => {
    dispatch({
        type: ON_HIDE_REPRESENTATIVE,
        payload: item
    });
    window.dispatchEvent(new Event('resize'));
};

export const onAddClick = item => dispatch => {
    dispatch({
        type: ON_SHOW_REPRESENTATIVE,
        payload: item
    });
    window.dispatchEvent(new Event('resize'));
};

export const onShowRepresentatives = () => dispatch => {
    setTimeout(() => {
        if (document.getElementById('addButton')) {
            const addButton = document.getElementById('addButton');
            const addButtonPosition = document
                .getElementById('addButton')
                .getBoundingClientRect().left;
            addButton.classList += ' visible';
            if (width() / 2 < addButtonPosition) {
                addButton.classList += ' to-right';
            }
        }
    });

    dispatch({
        type: ON_SHOW_LIST_WITH_REPS
    });
};



// WEBPACK FOOTER //
// ./src/containers/LocalRep/actions.js